export const contentSections = [
  {
    slug: 'exclusive',
    name: '独家爆料',
    icon: 'ri-flashlight-line',
    desc: '编辑部第一手线索，经初步核实后优先发布，通常附带时间线与信源说明。',
    feature: '每日 3–5 条',
    tone: 'primary',
  },
  {
    slug: 'investigation',
    name: '深度调查',
    icon: 'ri-file-search-line',
    desc: '长周期追踪报道，多信源交叉核实，单篇篇幅更长，适合完整了解事件背景。',
    feature: '每周 2–3 篇',
    tone: 'accent',
  },
  {
    slug: 'tracking',
    name: '热点追踪',
    icon: 'ri-radar-line',
    desc: '对正在发酵的话题做实时跟进，按时间顺序持续更新进展与各方回应。',
    feature: '持续更新',
    tone: 'secondary',
  },
  {
    slug: 'contribute',
    name: '网友投稿',
    icon: 'ri-user-voice-line',
    desc: '来自读者的亲历讲述与线索补充，经编辑整理后发布，保留当事人视角。',
    feature: '每日上稿',
    tone: 'primary',
  },
  {
    slug: 'fact-check',
    name: '辟谣专区',
    icon: 'ri-shield-cross-line',
    desc: '对流传较广的说法做求证与澄清，标注信息来源，避免误传继续扩散。',
    feature: '每周汇总',
    tone: 'accent',
  },
  {
    slug: 'guide',
    name: '维权指南',
    icon: 'ri-compass-3-line',
    desc: '把案例沉淀成可操作的步骤清单：如何留证、如何沟通、如何升级投诉渠道。',
    feature: '工具型内容',
    tone: 'secondary',
  },
];